import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { ANNOUNCEMENT_MODE } from '../../constants'

import {
    ANNOUNCEMENT_VIEW_TITLE,
    ANNOUNCEMENT_CREATE_TITLE,
    ANNOUNCEMENT_EDIT_TITLE,
} from '../../translations'

import styles from './Header.scss'

const getTitle = (mode) => {
    switch (mode) {
    case ANNOUNCEMENT_MODE.CREATE:
        return ANNOUNCEMENT_CREATE_TITLE
    case ANNOUNCEMENT_MODE.EDIT:
        return ANNOUNCEMENT_EDIT_TITLE
    default:
        return ANNOUNCEMENT_VIEW_TITLE
    }
}

export const Header = (props) => {
    const { withPaginationInfo, itemsLength, announcementMode, currentItem } = props

    const paginatorClassNames = classNames(
        styles.paginator,
        !withPaginationInfo && styles.paginator__hidden,
    )

    return (
        <div className={styles.base}>
            <div className={paginatorClassNames}>
                {`${currentItem} / ${itemsLength}`}
            </div>
            <h1 className={styles.title}>
                {getTitle(announcementMode)}
            </h1>
        </div>
    )
}

Header.propTypes = {
    withPaginationInfo: PropTypes.bool.isRequired,
    itemsLength: PropTypes.number.isRequired,
    announcementMode: PropTypes.oneOf(Object.values(ANNOUNCEMENT_MODE)).isRequired,
    currentItem: PropTypes.number.isRequired,
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/components/Header/Header.jsx